import React from 'react'
import {
  List,
  Datagrid,
  ChipField,
  TextField,
  ReferenceManyField,
  SingleFieldList,
  EditButton,
  ShowButton,
  Edit,
  SimpleForm,
  DisabledInput,
  TextInput,
  Create,
  DateInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  Show,
  SimpleShowLayout,
  LongTextInput,
} from 'admin-on-rest'

import { CourseView } from '../components/CourseView'

export const AdminCourseShow = props => (
  <Show {...props}>
    <SimpleShowLayout>
      <CourseView />
    </SimpleShowLayout>
  </Show>
)



// WEBPACK FOOTER //
// ./src/admin/AdminCourseShow.js